import api from '../services/api';

const assetModel = {
    /**
     * Get list of water pumps/assets
     * @param {Object} filters - { page, limit, active_only, station_id, search }
     * @returns {Promise}
     */
    getWaterPumps: async (filters = {}) => {
        try {
            const params = { ...filters };
            
            const response = await api.get('/api/external/water-pumps', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching water pumps:', error);
            throw error;
        }
    },

    /**
     * Get single water pump/asset details
     * @param {number} pumpId 
     * @returns {Promise}
     */
    getWaterPump: async (pumpId) => {
        try {
            const response = await api.get(`/api/external/water-pumps/${pumpId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching pump ${pumpId}:`, error);
            throw error;
        }
    }
};

export default assetModel;
